import React, {useContext, useEffect, useState} from 'react';
import {Button, message} from 'antd';
import ImportTableModal from '../common/ImportTableModal';
import EditComponent from '../common/EditComponent';
import DeleteComponent from '../common/DeleteComponent';
import {Arguments} from '../common/Arguments';
import {sideMenuContext} from '../../../router/IndexRouter';
import {GetApiMethod, PostToJava} from '../common/ApiMethod';
import {ExportToExcel} from '../common/ExportDataToExcelComponent';
import SearchBox from '../common/SearchBoxComponent';
import {SortByOrganizationPost} from '../common/SortListByPost';
import BatchDelTableComponent from '../common/BatchDelComponent';

export default function MemberPersonal(props) {
	const currentUrl = window.location.href;
	const {dataSource, setDataSource, setCopyDataSource} = useContext(sideMenuContext);
	const getApi = Arguments.host + '/society_organization/society/api!memberPersonal.do';
	const [selectedRowKeys, setSelectedRowKeys] = useState([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		setDataSource([]);
		GetApiMethod({getApi, setDataSource, setCopyDataSource});
	}, [getApi]);

	const onSelectChange = (newSelectedRowKeys) => {
		setSelectedRowKeys(newSelectedRowKeys);
	};

	const rowSelection = {
		selectedRowKeys,
		onChange: onSelectChange,
	};

	const hasSelected = selectedRowKeys.length > 0;

	const resetSelect = () => {
		setSelectedRowKeys([]);
	};

	const deleteSelected = () => {
		setLoading(true);
		const ids = selectedRowKeys.map(key => dataSource[key - 1].memberId);
		const batchDelApi = Arguments.host + '/society_organization/batchDelete/api!delMemberInfo.do';
		const postData = {
			delIds: ids.join('&&'),
		};
		PostToJava(batchDelApi, postData).then(res => {
			if (res?.data.code === 1) {
				message.success('批量删除成功');
			} else {
				message.error('删除失败');
			}
			setLoading(false);
			setSelectedRowKeys([]);
		}).then(() => GetApiMethod({getApi, setDataSource, setCopyDataSource}));
	};

	const columns = [
		{
			title: '序号',
			dataIndex: 'key',
			width: 90,
			sorter: (a, b) => a.key - b.key,
			sortDirections: ['ascend', 'descend'],
		},
		{
			title: '姓名',
			responsive: ['sm'],
			dataIndex: 'memberName',
			width: 80,
			sorter: (a, b) => a.memberName.localeCompare(b.memberName),
			sortDirections: ['ascend', 'descend'],
		},
		{
			title: '性别',
			responsive: ['lg'],
			dataIndex: 'memberSex',
			width: 70,
		},
		{
			title: '民族',
			responsive: ['lg'],
			dataIndex: 'memberMz',
			width: 70,
		},
		{
			title: '出生日期',
			responsive: ['sm'],
			dataIndex: 'memberBorn',
			width: 110,
		},
		{
			title: '政治面貌',
			responsive: ['sm'],
			dataIndex: 'memberZzmm',
			width: 100,
		},
		{
			title: '文化程度',
			responsive: ['sm'],
			dataIndex: 'memberEducational',
			width: 100,
		},
		{
			title: '社团职务',
			responsive: ['lg'],
			dataIndex: 'organizationPost',
			width: 110,
		},
		{
			title: '工作单位（或原）',
			responsive: ['lg'],
			dataIndex: 'memberUnit',
			width: 160,
		},
		{
			title: '职务',
			responsive: ['lg'],
			dataIndex: 'memberPost',
			width: 100,
		},
		{
			title: '职称',
			responsive: ['lg'],
			dataIndex: 'memberProfessional',
			width: 100,
		},
		{
			title: '操作',
			width: 150,
			render: (item) => (
				<>
					<EditComponent item={item} url={currentUrl}/>
					<DeleteComponent
						item={item}
						postApi={[Arguments.host + '/society_organization/society/api!addMemberPersonal.do']}
						getApi={getApi}
					/>
				</>
			),
		},
	];

	const newData = dataSource?.map(
		(
			{
				memberName,
				memberSex,
				memberMz,
				memberBorn,
				memberJg,
				memberZzmm,
				memberEducational,
				memberSpecial,
				memberResearch,
				organizationPost,
				memberUnit,
				memberUnitAttribute,
				memberPost,
				memberProfessional,
				memberSfz,
				memberMobilePhone,
			},
		) => (
			{
				'姓名': memberName,
				'性别': memberSex,
				'民族': memberMz,
				'出生日期': memberBorn,
				'籍贯': memberJg,
				'政治面貌': memberZzmm,
				'文化程度': memberEducational,
				'特殊人才': memberSpecial,
				'研究方向': memberResearch,
				'社团职务': organizationPost,
				'工作单位': memberUnit,
				'单位性质': memberUnitAttribute,
				'职务': memberPost,
				'职称': memberProfessional,
				'身份证号': memberSfz,
				'手机号': memberMobilePhone,
			}
		),
	);

	const indexDataSource = SortByOrganizationPost(dataSource).map((data, index) => ({key: index + 1, ...data}));

	const tableTitle = [
		'member_name',
		'member_sex',
		'member_mz',
		'member_born',
		'member_jg',
		'member_zzmm',
		'member_educational',
		'member_special',
		'member_research',
		'organization_post',
		'member_unit',
		'member_unit_attribute',
		'member_post',
		'member_professional',
		'member_sfz',
		'member_mobile_phone',
	];

	return (
		<>
			<Button type="primary" onClick={() => props.history.push('/society/member-personal/add')}
					style={{marginBottom: 10}}>新增</Button>
			<ImportTableModal
				titleText="个人会员信息导入"
				templateUrl={Arguments.reactUrl.replace('/#', '') + '/att/words/会员信息（个人）导入模板.xlsx'}
				uploadUrl={Arguments.host + '/society_organization/batchImport/api!memberInfo.do'}
				incrementId={'organization_member_info.member_id'}
				getApi={getApi}
				tableTitle={tableTitle}
				duplicateApi={Arguments.host + '/society_organization/society/api!duplicateMemberPersonal.do'}
			/>
			<ExportToExcel tableData={newData}/>
			<SearchBox placeholder="输入姓名/单位/政治面貌关键字"/>
			<Button type="primary" onClick={() => resetSelect()} disabled={!hasSelected} style={{marginLeft: 20}}>
				取消选择
			</Button>
			<Button type="primary" danger onClick={() => deleteSelected()} disabled={!hasSelected} loading={loading}
					style={{marginLeft: 10}}>
				全部删除
			</Button>
			<BatchDelTableComponent
				rowSelection={rowSelection}
				dataSource={indexDataSource}
				columns={columns}
				rowKey={(item) => item.key}
			/>
		</>
	);
}
